// extracted by mini-css-extract-plugin
export default {"emptyScreenContainer":"style_emptyScreenContainer__OyUW9"};